import { Component, Vue } from 'vue-property-decorator'
import * as echarts from 'echarts';
import {getCustomerConversionPubliceStatisticalData} from '@/api/customer'
import {
    lastMonth,
    lastQuarter,
    lastWeek, lastYear,
    thisMonth,
    thisQuarter,
    thisToday,
    thisWeek, thisYear,
    thisYesterday
} from "@/utils/dateTime";

@Component({})
export default class ConversionTransfromStatisticsData extends Vue {
    dataFilter = 0
    customerConversionPublicInCount = 0 // 调入公海总计
    customerConversionPublicOutCount = 0 // 捞取客户总计
    customerConversionPublicInActiveCount=0  //主动调入公海总计
    customerConversionPublicInPassiveCount=0  //被动调入公海总计

    isShow = true //只有部门权限才展示
    dialogVisible = false
    // employeeDetailsName = ''
    customerConversionFollowData = {}
    EduTemandData = []
    GradeData = []
    startWeek = '' // 本周开始
    endWeek = '' //本周结束
    startMonth = '' // 本月开始
    endMonth = ''  //本月结束
    startLastWeek = '' //上周开始
    endLastWeek = '' //上周结束
    startLastMonth = '' // 上月开始
    endLastMonth = ''  // 上月结束
    startQuarter = ''  // 本季度开始
    endQuarter = '' // 本季度结束
    startLastQuarter = '' //上季度开始
    endLastQuarter = '' //上季度结束
    startYear = '' // 本年开始
    endYear = '' // 本年结束
    timeStrDate = []
    today = ''
    yesterday = ''
    yesteryearStart = ''
    yesteryearEnd = ''
    timeType = '1'
    timeStr = ''

    created() {
        this.getDateInterval()
    }

    // methods
    async getData() {
        // 2022-7-25 加loading
        const loading = this.$loading({
            lock: true,
            text: '数据正在加载中……',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
        });
        const obj = {
            timeStr: this.timeStr
        }
        const data: any = await getCustomerConversionPubliceStatisticalData(obj)

        loading.close();
        const {
            customerConversionPublicInByUserIdList
            , customerConversionPublicInCount,
            customerConversionPublicOutByUserIdList
            , customerConversionPublicOutCount,
            customerConversionPublicUserInCount,
            customerConversionPublicSystemInCount,
            customerConversionPublicUserInByUserIdList,
            customerConversionPublicUserInBySystemIdList,
        } = data

        this.customerConversionPublicInCount = customerConversionPublicInCount // 调入公海总数
        this.customerConversionPublicOutCount = customerConversionPublicOutCount // 捞取公海客户总数
        this.customerConversionPublicInActiveCount = customerConversionPublicUserInCount // 捞取公海客户总数
        this.customerConversionPublicInPassiveCount = customerConversionPublicSystemInCount // 捞取公海客户总数
        this.initCustomerConversionPublicIn(customerConversionPublicInByUserIdList)  // 调入
        this.initCustomerConversionPublicOut(customerConversionPublicOutByUserIdList)  // 捞取

        this.initCustomerConversionPublicActive(customerConversionPublicUserInByUserIdList)
        this.initCustomerConversionPublicPassive(customerConversionPublicUserInBySystemIdList)


    }



    initCustomerConversionPublicIn(array) {
        let data = []
        if (array.length > 0) {
            data = array.map(item => ({ 'product': item.userRealName, '调入公海客户数': item.count }))
        } else {
            data = [{ 'product': '某某员工', '调入公海客户数': 0 }]
        }
        const chartDom = document.getElementById('customerConversionPublicIn');
        const myChart = echarts.init(chartDom as HTMLElement);


        const option = {
            title: {
                subtext: '调入公海客户数'
            },
            legend: {
                right: 10
            },
            tooltip: {
                trigger: 'item',
                show: true,
            },
            dataset: {
                dimensions: ['product', '调入公海客户数'],
                source: data
            },
            xAxis: {
                type: 'category',
                name: '员工姓名',
                nameTextStyle: {
                    widht: 20,
                    padding: [0,0,0,20]
                },
                triggerEvent: true,
                axisLabel: {
                    clickable: true,
                    interval: 0,
                    formatter: function (value) {
                        //x轴的文字改为竖版显示
                        const str = value.split("");
                        return str.join("\n");
                    }

                }
            },
            yAxis: [
                { type: 'value' }

                ],

            series: [
                {
                    type: 'bar',
                    yAxisIndex: 0,
                    barMinHeight: 3,
                    itemStyle: { color: '#6583F9', opacity: 0.7 },
                    label: { show: true, position: 'top' },

                    markLine: {
                        data: [{ type: 'average', name: 'Avg' }]
                    }
                },

            ]
        }

        myChart.on('mouseover', 'xAxis.category',(params) => {
            myChart.setOption({
                xAxis: {
                    axisLabel: {
                        color: function (val) {
                            return val == params.value ? '#1eb4ff' : '#666'
                        },
                    },
                }
            })
        });
        myChart.on('mouseout', function () {
            myChart.setOption({
                xAxis: {
                    axisLabel: {
                        color: '#666',
                        fontSize: 12
                    },
                }
            })
        })

        option && myChart.setOption(option);


    }




    initCustomerConversionPublicOut(array) {
        let data = []
        if (array.length > 0) {
            data = array.map(item => ({ 'product': item.userRealName, '捞取客户数': item.count }))
        } else {
            data = [{ 'product': '某某员工', '捞取客户数': 0 }]
        }
        const chartDom = document.getElementById('customerConversionPublicOut');
        const myChart = echarts.init(chartDom as HTMLElement);


        const option = {
            title: {
                subtext: '捞取客户数'
            },
            legend: {
                right: 10
            },
            tooltip: {
                trigger: 'item',
                show: true,
            },
            dataset: {
                dimensions: ['product', '捞取客户数'],
                source: data
            },
            xAxis: {
                type: 'category',
                name: '员工姓名',
                nameTextStyle: {
                    widht: 20,
                    padding: [0,0,0,20]
                },
                triggerEvent: true,
                axisLabel: {
                    clickable: true,
                    interval: 0,
                    formatter: function (value) {
                        //x轴的文字改为竖版显示
                        const str = value.split("");
                        return str.join("\n");
                    }

                }
            },
            yAxis: [
                { type: 'value' }

            ],

            series: [
                {
                    type: 'bar',
                    yAxisIndex: 0,
                    barMinHeight: 3,
                    itemStyle: { color: '#6583F9', opacity: 0.7 },
                    label: { show: true, position: 'top' },

                    markLine: {
                        data: [{ type: 'average', name: 'Avg' }]
                    }
                },

            ]
        }

        myChart.on('mouseover', 'xAxis.category',(params) => {
            myChart.setOption({
                xAxis: {
                    axisLabel: {
                        color: function (val) {
                            return val == params.value ? '#1eb4ff' : '#666'
                        },
                    },
                }
            })
        });
        myChart.on('mouseout', function () {
            myChart.setOption({
                xAxis: {
                    axisLabel: {
                        color: '#666',
                        fontSize: 12
                    },
                }
            })
        })

        option && myChart.setOption(option);

    }

    initCustomerConversionPublicActive(array) {
        let data = []
        if (array.length > 0) {
            data = array.map(item => ({ 'product': item.userRealName, '主动调入公海客户数': item.count }))
        } else {
            data = [{ 'product': '某某员工', '主动调入公海客户数': 0 }]
        }
        const chartDom = document.getElementById('customerConversionPublicActive');
        const myChart = echarts.init(chartDom as HTMLElement);


        const option = {
            title: {
                subtext: '主动调入公海客户数'
            },
            legend: {
                right: 10
            },
            tooltip: {
                trigger: 'item',
                show: true,
            },
            dataset: {
                dimensions: ['product', '主动调入公海客户数'],
                source: data
            },
            xAxis: {
                type: 'category',
                name: '员工姓名',
                nameTextStyle: {
                    widht: 20,
                    padding: [0,0,0,20]
                },
                triggerEvent: true,
                axisLabel: {
                    clickable: true,
                    interval: 0,
                    formatter: function (value) {
                        //x轴的文字改为竖版显示
                        const str = value.split("");
                        return str.join("\n");
                    }

                }
            },
            yAxis: [
                { type: 'value' }

                ],

            series: [
                {
                    type: 'bar',
                    yAxisIndex: 0,
                    barMinHeight: 3,
                    itemStyle: { color: '#6583F9', opacity: 0.7 },
                    label: { show: true, position: 'top' },

                    markLine: {
                        data: [{ type: 'average', name: 'Avg' }]
                    }
                },

            ]
        }

        myChart.on('mouseover', 'xAxis.category',(params) => {
            myChart.setOption({
                xAxis: {
                    axisLabel: {
                        color: function (val) {
                            return val == params.value ? '#1eb4ff' : '#666'
                        },
                    },
                }
            })
        });
        myChart.on('mouseout', function () {
            myChart.setOption({
                xAxis: {
                    axisLabel: {
                        color: '#666',
                        fontSize: 12
                    },
                }
            })
        })

        option && myChart.setOption(option);


    }
    initCustomerConversionPublicPassive(array) {
        let data = []
        if (array.length > 0) {
            data = array.map(item => ({ 'product': item.userRealName, '被动调入公海客户数': item.count }))
        } else {
            data = [{ 'product': '某某员工', '被动调入公海客户数': 0 }]
        }
        const chartDom = document.getElementById('customerConversionPublicPassive');
        const myChart = echarts.init(chartDom as HTMLElement);


        const option = {
            title: {
                subtext: '被动调入公海客户数'
            },
            legend: {
                right: 10
            },
            tooltip: {
                trigger: 'item',
                show: true,
            },
            dataset: {
                dimensions: ['product', '被动调入公海客户数'],
                source: data
            },
            xAxis: {
                type: 'category',
                name: '员工姓名',
                nameTextStyle: {
                    widht: 20,
                    padding: [0,0,0,20]
                },
                triggerEvent: true,
                axisLabel: {
                    clickable: true,
                    interval: 0,
                    formatter: function (value) {
                        //x轴的文字改为竖版显示
                        const str = value.split("");
                        return str.join("\n");
                    }

                }
            },
            yAxis: [
                { type: 'value' }

                ],

            series: [
                {
                    type: 'bar',
                    yAxisIndex: 0,
                    barMinHeight: 3,
                    itemStyle: { color: '#6583F9', opacity: 0.7 },
                    label: { show: true, position: 'top' },

                    markLine: {
                        data: [{ type: 'average', name: 'Avg' }]
                    }
                },

            ]
        }

        myChart.on('mouseover', 'xAxis.category',(params) => {
            myChart.setOption({
                xAxis: {
                    axisLabel: {
                        color: function (val) {
                            return val == params.value ? '#1eb4ff' : '#666'
                        },
                    },
                }
            })
        });
        myChart.on('mouseout', function () {
            myChart.setOption({
                xAxis: {
                    axisLabel: {
                        color: '#666',
                        fontSize: 12
                    },
                }
            })
        })

        option && myChart.setOption(option);


    }



    handleClose(done) {
        this.dialogVisible = false
    }



    //    初始化获取日期区间
    getDateInterval() {
        // 获取今天
        this.today = thisToday();

        // 获取昨天
        this.yesterday = thisYesterday();

        // 本周
        this.startWeek = thisWeek()[0]//周一日期
        this.endWeek = thisWeek()[1];//周日日期

        //上周
        this.startLastWeek = lastWeek()[0]; //周一日期
        this.endLastWeek = lastWeek()[1]; //周日日期

        // 本月
        this.startMonth = thisMonth()[0]
        this.endMonth = thisMonth()[1]

        // 上月
        this.startLastMonth = lastMonth()[0];
        this.endLastMonth = lastMonth()[1];

        // 本季度
        this.startQuarter = thisQuarter()[0];
        this.endQuarter = thisQuarter()[1];

        // 上季度
        this.startLastQuarter = lastQuarter()[0];
        this.endLastQuarter = lastQuarter()[1];

        //本年
        this.startYear = thisYear()[0];
        this.endYear = thisYear()[1];

        // 获取去年
        this.yesteryearStart = lastYear()[0];
        this.yesteryearEnd = lastYear()[1];

        if (this.timeType == '0') {
            this.timeStr = this.yesterday + '&' + this.yesterday
            this.timeStrDate = [this.yesterday, this.yesterday]
            this.getData()
        } else if (this.timeType == '1') {
            this.timeStr = this.today + '&' + this.today
            this.timeStrDate = [this.today, this.today]
            this.getData()
        }

    }
    // 选择区间
    changeDateType(val) {
        if (val === '2') {  //    本周
            this.timeStr = this.startWeek + '&' + this.endWeek
            this.timeStrDate = [this.startWeek,this.endWeek]
        } else if (val === '3') { // 本月
            this.timeStr = this.startMonth + '&' + this.endMonth
            this.timeStrDate = [this.startMonth,this.endMonth]
        } else if (val === '4') { // 本季度
            this.timeStr = this.startQuarter + '&' + this.endQuarter
            this.timeStrDate = [this.startQuarter,this.endQuarter]
        } else if (val === '5') { // 本年
            this.timeStr = this.startYear + '&' + this.endYear
            this.timeStrDate = [this.startYear,this.endYear]
        } else if (val === '6') { // 上周
            this.timeStr = this.startLastWeek + '&' + this.endLastWeek
            this.timeStrDate = [this.startLastWeek,this.endLastWeek]
        } else if (val === '7') { // 上月
            this.timeStr = this.startLastMonth + '&' + this.endLastMonth
            this.timeStrDate = [this.startLastMonth,this.endLastMonth]
        } else if (val === '8') { // 上季度
            this.timeStr = this.startLastQuarter + '&' + this.endLastQuarter
            this.timeStrDate = [this.startLastQuarter,this.endLastQuarter]
        } else if (val === '9') { // 去年
            this.timeStr = this.yesteryearStart + '&' + this.yesteryearEnd
            this.timeStrDate = [this.yesteryearStart,this.yesteryearEnd]
        }else if (val === '0') { // 昨天
            this.timeStr = this.yesterday + '&' + this.yesterday
            this.timeStrDate = [this.yesterday,this.yesterday]
        }else if (val === '1') { // 今天
            this.timeStr = this.today + '&' + this.today
            this.timeStrDate = [this.today,this.today]
        } else {
            this.timeStr = ''
            this.timeStrDate = []
        }


        if (this.timeStr) {
            this.getData()
        }

    }

    handleChangeData(val) {
        const  week = [this.startWeek,this.endWeek]
        const  month = [this.startMonth,this.endMonth]
        const  year = [this.startYear,this.endYear]
        const  quarter = [this.startQuarter,this.endQuarter]
        const  lastWeek = [this.startLastWeek,this.endLastWeek]
        const  lastMonth = [this.startLastMonth,this.endLastMonth]
        const  lastQuarter = [this.startLastQuarter,this.endLastQuarter]
        const  lastyear = [this.yesteryearStart,this.yesteryearEnd]
        const yesterday = [this.yesterday, this.yesterday]
        const today = [this.today, this.today]
        if (week[0].indexOf(val[0]) !== -1 && week[1].indexOf(val[1]) !== -1) {
            this.timeType = '2'
        } else if (month[0].indexOf(val[0]) !== -1 && month[1].indexOf(val[1]) !== -1) {
            this.timeType = '3'
        } else if (quarter[0].indexOf(val[0]) !== -1 && quarter[1].indexOf(val[1]) !== -1) {
            this.timeType = '4'
        } else if (year[0].indexOf(val[0]) !== -1 && year[1].indexOf(val[1]) !== -1) {
            this.timeType = '5'
        }  else if (lastWeek[0].indexOf(val[0]) !== -1 && lastWeek[1].indexOf(val[1]) !== -1) {
            this.timeType = '6'
        } else if (lastMonth[0].indexOf(val[0]) !== -1 && lastMonth[1].indexOf(val[1]) !== -1) {
            this.timeType = '7'
        } else if (lastQuarter[0].indexOf(val[0]) !== -1 && lastQuarter[1].indexOf(val[1]) !== -1) {
            this.timeType = '8'
        } else if (lastyear[0].indexOf(val[0]) !== -1 && lastyear[1].indexOf(val[1]) !== -1) {
            this.timeType = '9'
        }else if (yesterday[0].indexOf(val[0]) !== -1 && yesterday[1].indexOf(val[1]) !== -1) {
            this.timeType = '0'
        } else if (today[0].indexOf(val[0]) !== -1 && today[1].indexOf(val[1]) !== -1) {
            this.timeType = '1'
        } else {
            this.timeType = '自定义时间'
        }
        this.timeStr = val[0] + '&' + val[1]
        this.getData()
    }
}
